<template>
    <div class="step-four-container">
        <div class="subtitle">
            <span>{{ $t('intervention.stepfour.subtitle') }}</span>
        </div>
        <form class="form-container" @submit.prevent="submitForm">
            <div class="form-fields">
                <div class="input-container object-container">
                    <label class="label" :class="objetValue.trim() || objetFocus ? 'active-label' : ''" for="intervention-objet">{{
                        $t('app.ask.estimate.subject')
                    }}</label>
                    <input
                        id="intervention-objet"
                        class="object-input"
                        @blur="toggleObjetFocus(false)"
                        @focus="toggleObjetFocus(true)"
                        name="objet"
                        type="text"
                        v-model="objetValue"
                    />
                </div>
                <div class="input-container description-container">
                    <label class="label" :class="descriptifValue.trim() || descriptionFocus ? 'active-label' : ''" for="descriptif">{{
                        $t('intervention.stepfour.description')
                    }}</label>
                    <textarea
                        @blur="toggleDescriptionFocus(false)"
                        @focus="toggleDescriptionFocus(true)"
                        class="description-input"
                        name="descriptif"
                        id="descriptif"
                        cols="30"
                        maxlength="4000"
                        v-model="descriptifValue"
                    />
                </div>
            </div>
            <div class="documents-wrapper">
                <AddDocuments :documents="files" @add="addFile" @remove="removeFile" />
                <ReglePastille cle="demandeIntervention.piecesJointes" />
            </div>
        </form>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { INTERVENTION } from '../store/mutation-types';
import fr from 'date-fns/locale/fr';
import AddDocuments from '@/modules/Common/components/AddDocuments.vue';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    components: { AddDocuments, ReglePastille },
    data() {
        return {
            objetFocus: false,
            descriptionFocus: false,
            dateFocus: false,
        };
    },
    setup() {
        return fr;
    },
    name: 'EstimateForm',
    computed: {
        objetValue: {
            get() {
                return this.$store.getters.getInterventionObjetValue;
            },
            set(value: string) {
                this.$store.commit(INTERVENTION.SET_OBJET, value.trim());
            },
        },
        descriptifValue: {
            get() {
                return this.$store.getters.getInterventionDescriptifValue;
            },
            set(value: string) {
                this.$store.commit(INTERVENTION.SET_DESCRIPTIF, value.trim());
            },
        },
        files() {
            return this.$store.getters.getInterventionFiles;
        },
    },
    methods: {
        toggleObjetFocus(value: boolean) {
            this.objetFocus = value;
        },
        toggleDescriptionFocus(value: boolean) {
            this.descriptionFocus = value;
        },
        removeFile(file: File) {
            this.$store.commit(INTERVENTION.REMOVE_FILE, file);
        },
        addFile(file: File) {
            this.$store.commit(INTERVENTION.ADD_FILE, file);
        },
    },
});
</script>

<style scoped>
.step-four-container {
    padding: 16px 24px;
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    max-height: calc(100vh - 415px);
    overflow-y: auto;
}
.form-container {
    display: flex;
    width: 80%;
}
.form-fields {
    gap: 12px;
    padding-right: 90px;
    display: flex;
    flex-direction: column;
    width: 50%;
    border-right: 1px solid var(--medium-dark-grey);
}
.subtitle {
    margin-bottom: 16px;
}
.input-container {
    height: 16px;
    position: relative;
    display: flex;
    border: 1px solid var(--medium-dark-grey);
    border-radius: 4px;
    padding: 11px 12px;
    align-items: center;
}
.description-container {
    height: 180px;
}
.label,
.label-date {
    left: 12px;
    position: absolute;
    pointer-events: none;
    transition: 0.2s ease all;
    padding: 2px;
    background-color: var(--white);
    color: var(--medium-dark-grey);
    top: 8px;
    font-size: var(--font-size-low-medium);
}
.active-label {
    left: 12px;
    top: -8px;
    font-size: var(--font-size-very-small);
}
input,
textarea {
    width: 100%;
    font-family: Roboto;
    border: none;
    outline: none;
    color: var(--black);
}
textarea {
    resize: none;
    height: 100%;
}
.icon {
    margin: 0;
    height: 24px;
    width: 24px;
    justify-self: end;
    cursor: pointer;
}
.documents-wrapper {
    display: contents;
}
</style>
